import React, {useState, useMemo} from 'react'
import Tooltip from '../cta_utils/Tooltip';
import Icon from '../utils/Icon';

const passwordRules = {
    length: /.{8,}/,
    uppercase: /[A-Z]/,    
    lowercase: /[a-z]/,
    digit: /[0-9]/,
    special_characters: /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/
};
const formatRules = {
    "length": "Minimum 8 characters",
    "uppercase": "One uppercase letter (A-Z)",
    "lowercase": "One lowercase letter (a-z)",
    "digit": "One number (0-9)",
    "special_characters": "One special character (!@#$)"
}
const validatePassword = (password) => {
    let errors = {}    
    if(!password) return errors;
    Object.keys(passwordRules).forEach(rule => {
        let format = passwordRules[rule];
        if(!format.test(password)) errors[rule] = true;        
    })
    // if(Object.keys(errors).length !== 0) errors["box_message"] = "no_value"
    return errors;
}
const AnPasswordBox = ({
        errors,                         // required
        password,                       // required
        onChange,                       // required
        name = 'password',
        placeholder = 'password',
        tooltipEnable = true,
        ...props
    }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [showToolTip, setShowToolTip] = useState(false);
    let ruleSize = useMemo(() => {
        return Object.keys(formatRules).length
    }, [formatRules]) 
    return (
        <div style={{position: "relative"}}>
            <Tooltip tooltipText={() => {
                return Object.keys(formatRules).map((rule, i) => {                    
                    return (
                        <div key={rule} className="default_flex_container" style={{ marginBottom: (i !== ruleSize - 1) ? 8 : 0}}>
                            <Icon name={errors?.[rule] ? "RedFail" : "SuccessGreen"} width="12px" height="12px" alt="*" />
                            <div className="text_subtitle_semi_bold" style={{color: "white", lineHeight: '12px', marginLeft: 6}}>{formatRules[rule]}</div>
                        </div>
                    )
                })                
            }}
                enableTooltip={tooltipEnable && showToolTip && password}
                showTooltip={showToolTip}
                innerClass='text_body_light'
                textTheme='background-light-black right'
                innerStyle={{ padding: '12px', alignSelf: 'center', color: 'white', borderRadius: '8px'}}
                style={{ }}
                showWithoutOverflowing={true}
                tooltipPos="right"
                tooltTipOverlay={{x: 7, y: -36}}
            >
                <div style={{cursor: 'pointer'}}>
                    <input type={isVisible ? "text" : "password"} id={name} name={name} value={password} onChange={onChange} placeholder={placeholder}
                        onFocus={() => setShowToolTip(true)} onBlur={() => setShowToolTip(false)}
                    />
                    <Icon className='an_password_eye text_title' style={{marginRight: 12}} onClick={() => setIsVisible(s => !s)} name={isVisible ? "Hide" : "Show"}/>
                </div>
            </Tooltip>
        </div>
    )
}

export default AnPasswordBox
export {validatePassword}